import React from "react"
import { Modal, Form, Input, message } from "antd"
import PropTypes from 'prop-types'

class GroupEditFormModal extends React.PureComponent {

  constructor(props) {
    super(props)

    const { formData } = this.props

    this.state = {
      formData: {
        key: formData.key,
        name: formData.name,
        orderScore: formData.orderScore
      }
    }
  }

  onCancel() {
    this.props.onCancel()
  }

  onSubmit() {
    const { formData } = this.state
    const { isNew } = this.props

    // 表单数据校验
    if (!formData.key) {
      return message.warn("请输入分组标识")
    }

    if (!formData.name) {
      return message.warn("请输入分组名称")
    }

    if (!isNew && !formData.orderScore) {
      return message.warn("请输入排序值")
    }

    this.props.onSubmit(formData)
  }

  updateFormData(inputData) {
    const { formData } = this.state

    const newFormData = {
      ...formData,
      ...inputData
    }
    this.setState({
      formData: newFormData
    })
  }

  render() {

    const { formData } = this.state

    const { title, isNew } = this.props

    return (
      <Modal
        title={title}
        visible={true}
        maskClosable={false}
        keyboard={false}
        width={500}
        okText='保存'
        cancelText='取消'
        onOk={() => this.onSubmit()}
        onCancel={() => this.onCancel()}
      >
        <Form layout="vertical">
          <Form.Item label="分组标识">
            <Input
              placeholder="请输入分组标识"
              style={{ width: "100%" }}
              value={formData.key}
              onChange={(e) => this.updateFormData({ "key": e.target.value })}
            />
          </Form.Item>
          <Form.Item label="分组名称">
            <Input
              placeholder="请输入分组名称"
              style={{ width: "100%" }}
              value={formData.name}
              onChange={(e) => this.updateFormData({ "name": e.target.value })}
            />
          </Form.Item>

          {!isNew && (
            <Form.Item label="排序值">
              <Input
                placeholder="请输入排序值"
                style={{ width: "100%" }}
                value={formData.orderScore}
                onChange={(e) => this.updateFormData({ "orderScore": e.target.value })}
              />
            </Form.Item>
          )}
        </Form>
      </Modal>
    )
  }
}

GroupEditFormModal.propTypes = {
  isNew: PropTypes.bool,
  title: PropTypes.string,
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
}

export default GroupEditFormModal
